module.exports = __webpack_public_path__ + "static/nori-7b5a0fad656ce73ada4335fcedf5c487.png";